import { get, writable } from 'svelte/store';
import { unflatten } from 'devalue';
let serverStore;
const defaultStores = new Map();
const ssr = import.meta.env.SSR;
if (!ssr) {
    //@ts-ignore
    window.__preloadedStores__ = unflatten(window.__preloadedStores__);
}
async function initServerLocalStorage() {
    if (!serverStore) {
        const { AsyncLocalStorage } = await import('node:async_hooks');
        serverStore = new AsyncLocalStorage();
    }
}
const noop = () => { };
export function clientWritable(initialValue, start) {
    if (ssr) {
        const store = writable(initialValue);
        return {
            subscribe: store.subscribe,
            set: noop,
            update: noop
        };
    }
    else {
        return writable(initialValue, start);
    }
}
export function sharedWritable(name, initialState) {
    if (ssr) {
        defaultStores.set(name, initialState);
        return {
            subscribe(fn) {
                const st = getStore(name);
                return st.subscribe(fn);
            },
            set(v) {
                const st = getStore(name);
                return st.set(v);
            },
            update(fn) {
                const st = getStore(name);
                return st.update(fn);
            }
        };
    }
    else {
        // @ts-ignore
        return writable(window.__preloadedStores__[name]);
    }
}
export const setupStores = async (_, next) => {
    await initServerLocalStorage();
    await serverStore.run(getDefaultStore(), next);
};
export function getStoresValues() {
    if (!serverStore)
        throw new Error('Server store not loaded');
    const stores = serverStore.getStore();
    const result = {};
    if (!stores)
        return result;
    for (const [key, value] of stores) {
        result[key] = get(value);
    }
    return result;
}
function getStore(name) {
    if (!serverStore)
        throw new Error('Server store not loaded');
    const asyncStore = serverStore.getStore();
    if (!asyncStore)
        throw new Error(`Store ${name} was used before enter in a request`);
    if (!asyncStore.has(name))
        throw new Error(`Store ${name} cannot be found`);
    const requestStore = asyncStore.get(name);
    return requestStore;
}
function getDefaultStore() {
    const newStore = new Map();
    for (let [name, value] of defaultStores) {
        newStore.set(name, writable(value));
    }
    return newStore;
}
